module.exports = __webpack_public_path__ + "img/logo_mob.98a4cd7e.svg";